<app-modal-v2 #modal customClassName="diary-condition-modal">
    <div class="modal-content">
        <div class="modal-body">
          <div class="segment-culture-container">
            <app-segment-control #segmentControl (segmentIndexChange)="segmentIndexChanged($event)">
              <app-segment-control-item text="Details" [active]="true"></app-segment-control-item>
              <app-segment-control-item text="Conditions"></app-segment-control-item>
              <app-segment-control-item text="Action"></app-segment-control-item>
            </app-segment-control>

            <div class="culture-select" [ngClass]="{'visibility-hidden': shouldHideCultureSelect()}">
              <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture" [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)" searchInputPlaceholder="Search..."></app-input-select>
            </div>

            <div class="ignore-conditions" [class.visibility-hidden]="currentSegment !== 1">
              <form [formGroup]="form">
                <div>
                  <label class="checkbox">
                    <input type="checkbox" id="ignoreConditions" formControlName="ignoreConditions" value="true">
                    <span></span>
                  </label>
                  <label class="checkbox-label" for="ignoreConditions">Always Trigger This Rule</label>
                </div>
              </form>
            </div>
          </div>

            <form [formGroup]="form">
              <!-- Start: Details -->
              <div [ngClass]="{ 'visibility-hidden': currentSegment !== 0 }">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label>Rule Name <sup>*</sup></label>
                      <input type="text" formControlName="name" class="form-control" placeholder="Enter a name for the rule..."/>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label>Rule Description</label>
                      <input type="text" formControlName="description" class="form-control" placeholder="Enter an optional description for the rule..."/>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End: Details -->

              <!-- Start: Conditions -->
              <div class="rule-conditions-container" [ngClass]="{ 'visibility-hidden': currentSegment !== 1 }">
                @if (form.value.ignoreConditions) {
                  <div class="action-when">
                    <h3>When should this action occur?</h3>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox">
                          <input type="checkbox" id="showWhenEntryIncomplete" formControlName="showWhenEntryIncomplete" value="true">
                          <span></span>
                        </label>
                        <label class="checkbox-label" for="showWhenEntryIncomplete">
                          Before the patient completes today's e-Diary entry
                          <span class="checkbox-note">
                          The message will be shown to the patient before they complete their entry.
                        </span>
                        </label>
                      </div>

                      <div class="col-6">
                        <label class="checkbox">
                          <input type="checkbox" id="showWhenEntryComplete" formControlName="showWhenEntryComplete" value="true">
                          <span></span>
                        </label>
                        <label class="checkbox-label" for="showWhenEntryComplete">
                          After the patient completes today’s e-Diary entry
                          <span class="checkbox-note">
                          The message will be shown once the entry has been submitted.
                        </span>
                        </label>
                      </div>
                    </div>
                  </div>
                }

                <div [class.visibility-hidden]="form.value.ignoreConditions">
                  <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 20px;">
                    <!-- Start: Logical operator -->
                    <div class="logical-operator">
                      <app-input-select
                        [items]="logicalOperationOptions"
                        [parentForm]="form"
                        controlName="logicalOperator"
                      ></app-input-select>
                    </div>
                    <!-- End: Logical operator -->

                    <app-button text="Add Condition"
                                variant="info"
                                size="sm"
                                type="button"
                                (clicked)="onAddCondition()"
                    />
                  </div>

                  <!-- Start: Conditions list -->
                  <div style="display: flex; flex-direction: column; gap: 10px;">
                    <div *ngFor="let expression of form.get('expressions').value; let i = index">
                      <app-trial-diary-add-rule-condition
                        [elements]="diaryForm.elements || []"
                        [expression]="expression"
                        [elementOptions]="elementOptions"
                        [logicalOperator]="form.get('logicalOperator').value"
                        (remove)="onRemoveCondition(i)"
                      ></app-trial-diary-add-rule-condition>
                    </div>
                  </div>
                  <!-- End: Conditions list -->
                </div>
              </div>
              <!-- End: Conditions -->
            </form>

          <!-- Start: Action -->
          <div class="rule-conditions-container" [ngClass]="{ 'visibility-hidden': currentSegment !== 2 }">
            <form [formGroup]="form">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>Action</label>
                    <app-input-select
                      [items]="filteredActionOptions"
                      [parentForm]="form"
                      controlName="action"
                    ></app-input-select>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-group" [ngClass]="{ 'visibility-hidden': form.get('action').value !== '0' }">
                    <label>Text Style</label>
                    <app-input-select
                      [items]="textStyleOptions"
                      [parentForm]="form"
                      controlName="messageStyle"
                    ></app-input-select>
                  </div>
                </div>
              </div>

              <!-- Start: Default culture (en) -->
              <div [ngClass]="{ 'visibility-hidden': form.get('selectedCulture').value !== 'en' }">
                <div [ngClass]="{ 'visibility-hidden': form.get('action').value !== '1' }">
                  <div class="form-group">
                    <label>Email Subject<sup>*</sup></label>
                    <input type="text" formControlName="emailSubject" class="form-control" placeholder="Enter a subject for the email..."/>
                  </div>

                  <div class="form-group">
                    <label>Email Content<sup>*</sup></label>
                    <textarea type="text" formControlName="emailText" class="form-control" placeholder="Enter a body for the email..."></textarea>
                  </div>
                </div>

                <div [ngClass]="{ 'visibility-hidden': form.get('action').value !== '0' }">
                  <div class="form-group">
                    <label>Text<sup>*</sup></label>
                    <textarea type="text" formControlName="messageText" class="form-control" placeholder="Enter a text..."></textarea>
                  </div>
                </div>
              </div>
              <!-- End: Default culture (en) -->
            </form>

            <!-- Start: Culture Forms -->
            <ng-container *ngFor="let cultureForm of cultureForms">
              <form [formGroup]="cultureForm">
                <div [ngClass]="{ 'visibility-hidden': cultureForm.value.culture !== form.get('selectedCulture').value }">
                  <div [ngClass]="{ 'visibility-hidden': form.get('action').value !== '1' }">
                    <div class="form-group">
                      <label>Email Subject</label>
                      <input type="text" formControlName="emailSubject" class="form-control" placeholder="Enter a subject for the email..."/>
                    </div>

                    <div class="form-group">
                      <label>Email Content</label>
                      <textarea type="text" formControlName="emailText" class="form-control" placeholder="Enter a body for the email..."></textarea>
                    </div>
                  </div>

                  <div [ngClass]="{ 'visibility-hidden': form.get('action').value !== '0' }">
                    <div class="form-group">
                      <label>Text</label>
                      <textarea type="text" formControlName="messageText" class="form-control" placeholder="Enter a text..."></textarea>
                    </div>
                  </div>
                </div>
              </form>
            </ng-container>
            <!-- End: Culture Forms -->

            <!-- Start: Tokens -->
            <div class="tokens">
              <h3>Tokens</h3>
              <ul>
                <li *ngFor="let token of tokens"><span>{{ '{'+token.key+'}' }}</span> <span>{{ token.description }}</span></li>
              </ul>
            </div>
            <!-- End: Tokens -->
          </div>
          <!-- End: Action -->
        </div>

        <div class="modal-footer">
            <div class="modal-footer-buttons">
                <app-button text="Cancel" variant="secondary" width="fill"
                            type="button" (click)="hide()"/>

                <app-button text="Apply" [disabled]="isApplyButtonDisabled()" variant="primary"
                            width="fill"
                            type="button" (clicked)="onApply()"/>
            </div>
        </div>

    </div>
</app-modal-v2>
